import React from 'react';
import { Hero, HeroBackground } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import { parseHtml } from '../../utils/util';

const HeroBanner = ({
  bgProps,

}) => (
  <div className="col-md-12 ">
    <Hero
      theme={{
        color: '#fff !important',
        fill: '#fff !important',
      }}

    >
      <div
        className="text-align-left"
        style={{
          left: '30px', position: 'absolute',
        }}
      >
        <h1 className={bgProps.style}>{parseHtml(bgProps.headertext)}</h1><br />
        <p className={bgProps.style}>{parseHtml(bgProps.subtext)}</p>
      </div>
      <HeroBackground
        backgroundImageUrl={bgProps.tabimgSrc}
        overlayColor={bgProps.overlay}
      />
      <HeroBackground
        backgroundImageUrl={bgProps.imgSrc}
        overlayColor={bgProps.overlay}
      />
    </Hero>
  </div>

);

HeroBanner.propTypes = {
  bgProps: PropTypes.string,
};

export default HeroBanner;
